import React, { useState, useEffect } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import Comm from '../comm/comm';
import Tools from '../tools/tools';
import ModalInput from '../controls/ModalInput';
import { toast } from 'react-toastify';
import ModalConfirm from '../controls/ModalConfirm';
import ModalUpload from '../controls/ModalUpload';
import EstateEdit from '../controls/EstateEdit';
import { Redirect } from 'react-router-dom';
import PropertiesContainer from './PropertiesContainer';
import keycloak from '../tools/keycloak';


const RequestMain = (props) => {
    let [data, setData] = useState();
    let [requestState, setRequestState] = useState(30);
    let [priceModalVisible, setPriceModalVisible] = useState(false);
    let [paidModalVisible, setPaidModalVisible] = useState(false);
    let [archiveConfirmModalVisible, setArchiveConfirmModalVisible] = useState(false);
    let [fileModalVisible] = useState(false);
    let [newActivity, setNewActivity] = useState(false);
    let [acstreModalVisible, setAcstreModalVisible] = useState(false);

    const requestId = sessionStorage.getItem("requestId");
    let requestStates = [
        {
            key: "30", label: "Очаква плащане"
        },
        {
            key: "10", label: "В процес на обработка в НИНКН"
        },
        {
            key: "20", label: "В процес на обработка в МК"
        },
        {
            key: "2", label: "Приключена"
        },
    ]

    const canBeEdited = () => {
        return keycloak.userInfo.preferred_username === data.givenTo;
    }


    useEffect(() => {
        async function fetchData() {
            if (!requestId)
                return;

            Comm.Instance().get(`request?requestId=${requestId}`).then(result => {
                console.log("result.data", result.data);
                setRequestState(result.data.requestStateId);
                setData(result.data);

            }).catch(error => Tools.ProcessError(error))
        };
        fetchData();
    }, []);

    const postRequestState = (value) => {

        let dta = { ...data };
        dta.requestStateId = parseInt(value);
        Comm.Instance().put('api/requeststate', dta).then(r => {
            setRequestState(value);
            toast.info("Статусът е променен");
        });
    }



    const savePrice = (x) => {
        data.price = parseFloat(x) || 0;
        Comm.Instance().post('requestprice', data).then(result => {
            setData({ ...data });
            setPriceModalVisible(false);
            toast.info("Цената е записана");
        }).catch(error => Tools.ProcessError(error))


    };

    const saveAcstreNum = (x) => {
        data.acstreNum = x || "";
        Comm.Instance().post('requestacstrenum', data).then(result => {
            setData({ ...data });
            setAcstreModalVisible(false);
            toast.info("Номерът е записан");
        }).catch(error => Tools.ProcessError(error))


    };


    const savePaid = (x) => {
        data.paid = parseFloat(x) || 0;
        Comm.Instance().post('requestpaid', data).then(result => {
            setData({ ...data });
            setPaidModalVisible(false);
            toast.info("Сумата е записана");
        }).catch(error => Tools.ProcessError(error))


    };


    const archive = (ok) => {
        if (ok) {
            data.archive = !data.archive;
            Comm.Instance().post('requestarchive', data).then(result => {
                setData({ ...data });
                toast.info("Промяната е записана");
            }).catch(error => Tools.ProcessError(error))

        }
        setArchiveConfirmModalVisible(false);
    }

    const sendToSIS = () => {
        Comm.Instance().post('requestSendToSys', data).then(result => {
            toast.info("Преписката е изпратена към СИС");
        }).catch(error => Tools.ProcessError(error))

    }

    const setValue = (id, value) => {
        data[id] = value;
        setData({ ...data });
    }

    if (newActivity) {
        return <Redirect to="/RequestActivities" />
    }
    if (!requestId) {
        return (<Redirect to="/MyJobs" />);
    }

    if (!data)
        return (
            <div className="container">
                <ClipLoader
                    size={150}
                    color={"#123abc"}
                    loading={!data}
                />
            </div>
        );

    if (data.requestTypeId >= 10) {
        return (<Redirect to={`/ObjectPage/${data.requestId}`} />)
    }

    return (
        <>
            <div className="container">
                <h2 className="appeal-title mb-5">{data.numName} {data.name}</h2>

                <PropertiesContainer obj={JSON.parse(data.data)} readonly={true} />

                <EstateEdit data={data} setValue={setValue} readonly={true} />
                <div className="form-row">
                    <div className="form-group col-md-4">
                        <label htmlFor="inputCity"><b>Дата на подаване:</b> {Tools.FormatDate(data.createdOn)}</label>
                    </div>
                    <div className="form-group col-md-4">
                        <label htmlFor="inputCity"><b>Номер на преписка:</b> {data.numName}</label>
                    </div>
                    <div className="form-group col-md-2">
                        <label htmlFor="inputCity"><b>Цена:</b> {data.price.toFixed(2)}</label>
                    </div>
                    <div className="form-group col-md-2">
                        <label htmlFor="inputCity"><b>Платено:</b> {data.paid.toFixed(2)}</label>
                    </div>

                </div>
                <div className="form-row">
                    <div className="form-group col-md-4">
                        <label><b>Входящ номер от АКСТЪР:</b> {data.acstreNum}</label>
                    </div>
                    <div className="form-group col-md-2">

                        <label><b>Статус:</b></label>
                        <select value={requestState} onChange={(v) => postRequestState(v.target.value)} disabled={!canBeEdited(data.requestStateId)}>
                            {
                                requestStates.map(item => <option value={item.key} key={item.key}>{item.label}</option>)
                            }
                        </select>
                    </div>
                </div>
            </div>
            <div className="container">
                {/*{canBeEdited(data.requestStateId) && <button type="button" className="btn btn-primary" onClick={() => setNewActivity(true)}>Нова дейност</button>}*/}
                {/*{data.requestStateId === 1 && <button type="button" className="btn btn-success" onClick={() => setPriceModalVisible(true)}>Определяне на цена</button>}*/}
                {/*{data.requestStateId === 1 && <button type="button" className="btn btn-success" onClick={() => setPaidModalVisible(true)}>Платена сума</button>}*/}
                {/*{data.requestStateId !== 2 && <button type="button" className="btn btn-success" onClick={() => setAcstreModalVisible(true)}>Вх. номер от АКСТЪР</button>}*/}
                <button type="button" className="btn btn-primary" onClick={() => setNewActivity(true)} disabled={!canBeEdited()}>Нова дейност</button>
                <button type="button" className="btn btn-success" onClick={() => setPriceModalVisible(true)} disabled={!canBeEdited()}>Определяне на цена</button>
                <button type="button" className="btn btn-success" onClick={() => setPaidModalVisible(true)} disabled={!canBeEdited()}>Платена сума</button>
                <button type="button" className="btn btn-success" onClick={() => setAcstreModalVisible(true)} disabled={!canBeEdited()}>Вх. номер от АКСТЪР</button>

                <button type="button" className="btn btn-success" onClick={() => sendToSIS()} disabled={!canBeEdited()}>Прехвърляне в СИС</button>
                <button type="button" className="btn btn-danger" onClick={() => setArchiveConfirmModalVisible(true)} disabled={!canBeEdited()}>{!data.archive ? "Архивиране" : "Деархивиране"}</button>
                {/*<button type="button" className="btn btn-warning" onClick={() => setfileModalVisible(true)}>Експорт</button>*/}
            </div>
            <ModalInput display={acstreModalVisible} closeFunc={() => setAcstreModalVisible(false)} saveFunc={(x) => saveAcstreNum(x)} value={data.acstreNum} dataType="text" title="Входящ номер от акстър" />
            <ModalInput display={priceModalVisible} closeFunc={() => setPriceModalVisible(false)} saveFunc={(x) => savePrice(x)} value={data.price} dataType="number" title="Цена" />
            <ModalInput display={paidModalVisible} closeFunc={() => setPaidModalVisible(false)} saveFunc={(x) => savePaid(x)} value={data.paid} dataType="number" title="Платени" />
            <ModalConfirm display={archiveConfirmModalVisible} closeFunc={(val) => archive(val)} title="Моля, потвърдете" />
            <ModalUpload display={fileModalVisible} closeFunc={(val) => archive(val)} />
        </>

    );
}


export default RequestMain;

